module.exports = __webpack_public_path__ + "img/dmitry_starostov.6c1f413.jpg";